export default {
  Coworkers: {
    Number: 'شماره شناسایی',
    Name: 'نام و نام خانوادگی',
    Skills: 'مهارت ها',
    Installer: {
      Menu: ' نصاب و ابعاد بردار',
      Add: 'افزودن نصاب / ابعاد بردار',
      Edit: 'ویرایش نصاب / ابعاد بردار',
    },
    Manager: {
      Menu: 'کارمندان',
      Add: 'افزودن کارمند',
      Edit: 'ویرایش کارمند',
    },
    Placeholder: {
      Name: 'لطفا نام و نام خانوادگی را وارد کنید. ',
      PhoneNumber: 'لطفا شماره همراه را وارد کنید. ',
    },
  },
}
